import * as React from 'react';

function AZ(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.117 13.725H5.401l-.474 1.536H2.809l3.016-8.222h1.863l3.038 8.222H8.597l-.48-1.536zm-2.242-1.53h1.768l-.887-2.852-.88 2.851zm7.924.26h-3.393V10.98h3.393v1.474zm2.639 1.281h3.93v1.525h-6.404v-1.045l3.92-5.647h-3.942V7.04h6.387v1.016l-3.891 5.681z"
        fill="currentColor"
      />
    </svg>
  );
}

export default AZ;
